import { isNumber, map } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  root: {
    width: '50px',
  },
}));

export default function BoxesReceivedInput(props) {
  const { disabled = false } = props;
  const { classes } = useStyles();
  const [boxesReceived, setBoxesReceived] = useState(
    props.delivery.boxes_received || 0,
  );

  function onChange(n) {
    if (!isNumber(+n)) return;

    setBoxesReceived(n);

    props.onUpdate(
      props.delivery.id,
      { id: props.delivery.id, boxes_received: n },
      map(props.delivery.purchase_orders, 'po_number'),
    );
  }

  return (
    <TextField
      variant="standard"
      disabled={disabled || !props.delivery.delivered_at}
      classes={{ root: classes.root }}
      name="boxes_received"
      value={boxesReceived}
      margin="normal"
      InputLabelProps={{ shrink: true }}
      inputProps={{ step: 60 }}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

BoxesReceivedInput.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  delivery: PropTypes.shape({
    id: PropTypes.string.isRequired,
    boxes_received: PropTypes.string,
    purchase_orders: PropTypes.arrayOf(PropTypes.shape({})),
    delivered_at: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool,
};
